import common from './common'
import toGIF from './toGIF'
import convert from './convert'
import upload from './upload'
import addLipShape from './addLipShape'
import dynamicPhoto from './dynamicPhoto'
import audioCompress from './audioCompress'
import audioExtractor from './audioExtractor'
import audioJoiner from './audioJoiner'
import audioCutAndSpeedAndVolume from './audioCutAndSpeedAndVolume'
import audioAddMusic from './audioAddMusic'
import imageCutout from './imageCutout'
import videoCompress from './videoCompress'
import videoMute from './videoMute'
import purchase from './purchase'
import advertise from './advertise'
import screenRecorder from './screenRecorder'
import userLoginTips from './userLoginTips'
export default {
  common: {
    ...common
  },
  toGIF: {
    ...toGIF
  },
  convert: {
    ...convert
  },
  upload: {
    ...upload
  },
  addLipShape: {
    ...addLipShape
  },
  dynamicPhoto: {
    ...dynamicPhoto
  },
  audioCompress: {
    ...audioCompress
  },
  audioExtractor: {
    ...audioExtractor
  },
  audioJoiner: {
    ...audioJoiner
  },
  audioCutAndSpeedAndVolume: {
    ...audioCutAndSpeedAndVolume
  },
  audioAddMusic: {
    ...audioAddMusic
  },
  imageCutout: {
    ...imageCutout
  },
  videoCompress: {
    ...videoCompress
  },
  videoMute: {
    ...videoMute
  },
  purchase: {
    ...purchase
  },
  advertise: {
    ...advertise
  },
  screenRecorder: {
    ...screenRecorder
  },
  userLoginTips: {
    ...userLoginTips
  }
}
